import script from "./ClientManagePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientManagePage.vue?vue&type=script&setup=true&lang=ts"

import "./ClientManagePage.vue?vue&type=style&index=0&id=45bb28f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45bb28f7"]])

export default __exports__